import React, { useState, useEffect } from 'react';
import FieldDropdown from '../../../../../components/FieldDropdown/FieldDropdown';
import FieldText from '../../../../../components/FieldText/FieldText';
import PanelBase from '../../../../../components/PanelBase/PanelBase';
import { Row, Col, message } from 'antd';
import { constData } from '../../../../../const/Const';
import FieldDate from '../../../../../components/FieldDate/FieldDate';
import { API } from '../../../../../API/API';
import FieldNumber from '../../../../../components/FieldNumber/FieldNumber';
import ButtonSecondary from '../../../../../components/ButtonSecondary/ButtonSecondary';
import ButtonDefault from '../../../../../components/ButtonDefault/ButtonDefault';
import { MessageConst } from '../../../../../const/MessageConst';
import GridAdditionalYear from '../../../../../components/GridAdditionalYear/GridAdditionalYear';

const HRExtraNew = (props) => {

    const [initData, setInitData] = useState({
        "extraid": -1,
        "name": null,
        "extratypeid": null,
        "calctype": null,
        "calcmethod": null,
        "count": null,
        "infimum": null,
        "supremum": null,
        "frequency": null,
        "enddate": null,
        "begindate": null,
        "isactive": true,
        "extracalcs": [],
        "govcategoryid": [],
        "jobcategoryid": [],
        "jobsubcategoryid": [],
        "positionoccid": null,
        "companyid": null,
        "economictypeid": [],
        "subeconomictypeid": [],
        "labourcondition": []
    });

    const [checkRule, setCheckRule] = useState(false);
    const [data, setData] = useState({ ...initData });
    const [colSpan, setColSpan] = useState(window.innerWidth > 800 ? 12 : 24);
    const [dExtraType, setDExtraType] = useState([]);
    const [dCalcType, setDCalcType] = useState(constData.hrExtra_CalcType);
    const [dCalcMethod, setDCalcMethod] = useState(constData.hrExtra_CalcMethod);
    const [dFrequency, setDFrequency] = useState(constData.hrExtra_Frequency);
    const [step, setStep] = useState(1);
    const [loading, setLoading] = useState(false);

    const getExistsData = async () => {
        let tData = { ...initData };
        if (props.extraid) {
            await API.get('/api/humanresource/payroll/get_extra?extraid=' + props.extraid).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    if (response.data?.retdata?.length > 0) {
                        tData = response.data.retdata[0];
                    }
                }
            });
        }
        setData(tData);
    }

    useEffect(() => {
        getExistsData();
    }, [props.extraid]);

    const getConstData = async () => {
        let tDExtraType = [];

        setLoading(true);
        await API.get('/api/humanresource/payroll/get_extra_type_dropdown').then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                tDExtraType = response.data.retdata;
            }
        });

        setLoading(false);
        setDExtraType(tDExtraType);

    }

    useEffect(() => {
        getConstData();
    }, []);

    const onDismiss = () => {
        setData({ ...initData });
        setCheckRule(false);
        setStep(1);
        props.onDismiss();
    }

    const fieldOnChanged = async (key, text, field, fieldname) => {
        if (field) {
            let tData = { ...data };
            tData[field] = key;

            if (fieldname) {
                tData[fieldname] = text;
            }

            if (field == 'extratypeid' && key) {
                let tDExtraType = dExtraType?.find(r => r.key == key);
                if (tDExtraType && tDExtraType.isgovyear) {
                    tData.isgovyear = true;
                } else {
                    tData.isgovyear = false;
                }
            }

            setData(tData);
        }
    }

    const onSave = async () => {

        let vRule = true;
        setCheckRule(true);

        if (data.calcmethod == "SR") {
            if (!data.infimum
                || !data.supremum) {
                vRule = false;
            }
        } else {
            if (!data.count) {
                vRule = false;
            }
        }

        if (!data.extratypeid
            || !data.name
            || !data.calctype
            || !data.calcmethod
            || !data.frequency
            || !data.begindate) {
            vRule = false;
        }

        if (vRule) {

            let tData = { ...data };
            let tDataExtracalcs = tData?.extracalcs?.filter(r => r.rowstate > 0);
            tData.extracalcs = tDataExtracalcs;

            setLoading(true);
            await API.post('/api/humanresource/payroll/save_extra', [tData]).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    message.success(MessageConst.success);
                    props.afterSave();
                    onDismiss();
                }
            });
            setLoading(false);
        }
    }

    const onDelete = async () => {
        if (props.extraid) {
            await API.post('/api/humanresource/payroll/delete_extra?extraid=' + props.extraid).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    message.success(MessageConst.success);
                    props.afterSave();
                    onDismiss();
                }
            });
        }
    }

    let vPanel = null;
    if (step == 2) {
        vPanel = (
            <div>
                <GridAdditionalYear onChanged={fieldOnChanged} keyfield='extracalcs' defaultValue={data.extracalcs} />
            </div>
        );
    } else {
        vPanel = (
            <div>
                <Row gutter={[16, 16]} style={{ marginTop: 25 }}>
                    <Col span={colSpan}>
                        <FieldDropdown loading={loading} required onChanged={fieldOnChanged} title="Нэмэгдлийн төрөл" data={dExtraType} keyfield='extratypeid' defaultValue={data.extratypeid} checkreq={checkRule} />
                    </Col>
                    <Col span={colSpan}>
                        <FieldText loading={loading} required onChanged={fieldOnChanged} title="Нэмэгдлийн нэр" keyfield='name' defaultValue={data.name} checkreq={checkRule} />
                    </Col>
                </Row>
                <Row gutter={[16, 16]} style={{ marginTop: 13 }}>
                    <Col span={colSpan}>
                        <FieldDropdown loading={loading} required onChanged={fieldOnChanged} title="Давтамж" data={dFrequency} keyfield='frequency' defaultValue={data.frequency} checkreq={checkRule} />
                    </Col>
                    <Col span={colSpan}>
                        <FieldDropdown loading={loading} required onChanged={fieldOnChanged} title="Тооцох төрөл" data={dCalcType} keyfield='calctype' defaultValue={data.calctype} checkreq={checkRule} />
                    </Col>
                </Row>
                <Row gutter={[16, 16]} style={{ marginTop: 13 }}>
                    <Col span={colSpan}>
                        <FieldDropdown loading={loading} required onChanged={fieldOnChanged} title="Дүн тооцох арга" data={dCalcMethod} keyfield='calcmethod' defaultValue={data.calcmethod} checkreq={checkRule} />
                    </Col>
                    <Col span={colSpan}>
                        {data.calcmethod == "SR" ? (
                            <Row gutter={[16, 16]}>
                                <Col span={12}>
                                    <FieldNumber loading={loading} required onChanged={fieldOnChanged} title="Нэмэгдлийн доод хязгаар" keyfield='infimum' defaultValue={data.infimum} checkreq={checkRule} />
                                </Col>
                                <Col span={12}>
                                    <FieldNumber loading={loading} required onChanged={fieldOnChanged} title="Нэмэгдлийн дээд хязгаар" keyfield='supremum' defaultValue={data.supremum} checkreq={checkRule} />
                                </Col>
                            </Row>
                        ) : (
                            <FieldNumber loading={loading} required onChanged={fieldOnChanged} title="Нэмэгдлийн хэмжээ" keyfield='count' defaultValue={data.count} checkreq={checkRule} />
                        )}
                    </Col>
                </Row>
                <Row gutter={[16, 16]} style={{ marginTop: 13 }}>
                    <Col span={colSpan}>
                        <FieldDate loading={loading} required onChanged={fieldOnChanged} title="Эхлэх огноо" keyfield='begindate' defaultValue={data.begindate} checkreq={checkRule} />
                    </Col>
                    <Col span={colSpan}>
                        <FieldDate loading={loading} onChanged={fieldOnChanged} title="Дуусах огноо" keyfield='enddate' defaultValue={data.enddate} />
                    </Col>
                </Row>
            </div>
        );
    }

    const nextStep = () => {

        let vRule = true;
        setCheckRule(true);

        if (data.calcmethod == "SR") {
            if (!data.infimum
                || !data.supremum) {
                vRule = false;
            }
        } else {
            if (!data.count) {
                vRule = false;
            }
        }

        if (!data.extratypeid
            || !data.name
            || !data.calctype
            || !data.calcmethod
            || !data.frequency
            || !data.begindate) {
            vRule = false;
        }

        if (vRule) {
            setCheckRule(false);
            setStep(r => r + 1);
        }
    }

    const prevStep = () => {
        setStep(r => r - 1);
    }

    return (
        <div>
            <PanelBase
                isOpen={props.isOpen}
                headerText={(props.extraid ? "Нэмэгдэл засах" : "Нэмэгдэл нэмэх") + (data.isgovyear ? (" " + step + "/2") : "")}
                onDismiss={onDismiss}
                PanelType='large'
                buttons={
                    <div style={{ display: 'flex' }}>
                        {props.extraid ? (
                            <div style={{ marginRight: 16 }}>
                                <ButtonSecondary text='Устгах' onClick={onDelete} />
                            </div>
                        ) : null}
                        <div>
                            {data.isgovyear ? (
                                step == 1 ? (
                                    <ButtonSecondary text='Үргэлжлүүлэх' onClick={nextStep} />
                                ) : (
                                    <div style={{ display: 'flex' }}>
                                        <div style={{ marginRight: 16 }}>
                                            <ButtonSecondary text='Буцах' onClick={prevStep} />
                                        </div>
                                        <div>
                                            <ButtonDefault text='Хадгалах' onClick={onSave} />
                                        </div>
                                    </div>
                                )
                            ) : (
                                <ButtonDefault text='Хадгалах' onClick={onSave} />
                            )}
                        </div>
                    </div>
                }
            >
                {vPanel}
            </PanelBase>
        </div>
    );
}

export default HRExtraNew;